import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthMain from "../AuthMain";
import { Input } from "components/shared/Input";

//Hooks
import useUserNameValidation from "hooks/useUserNameValidation";

//contexts
import { UserContext } from "state/user/userContext";
import { GlobalContext } from "state/global/globalContext";

//Request
import { request } from "utils/request";

const RequestForgetPassword = () => {
    //State
    const [username, setUsername] = useState("");
    const [error, setError] = useState("");

    //const
    const history = useHistory();

    //Custom Hooks
    const userNameValid = useUserNameValidation(username);

    //useContext
    const { dispatch } = useContext(UserContext);
    const { setErrorRecived, setLoading } = useContext(GlobalContext);

    const requestForgetPassword = () => {
        if (!userNameValid) {
            setError(true);
        } else {
            setLoading(true);
            request
                .post("/api/users/forgotPassword.json", JSON.stringify({ mobile: username }))
                .then((res) => {
                    setLoading(false);
                    if (res?.data.state) {
                        dispatch({
                            type: "setPhoneNumber",
                            payload: username,
                        });
                        // setPhoneNumber(username);
                        history.push("/otp?forgetpassword");
                    } else {
                        setErrorRecived(res?.data.message);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setErrorRecived("لطفا چند لحظه دیگر مجدد تلاش کنید");
                });
        }
    };

    return (
        <AuthMain title="فراموشی رمز عبور" buttonText="بازیابی رمز عبور" onClickButton={requestForgetPassword}>
            <Input
                type="text"
                placeholder="شماره همراه"
                onInput={(e) => setUsername(e.target.value)}
                align="left"
                icon="icon-smartphone"
                error={error && !userNameValid && "شماره موبایل خود را به صورت صحیح وارد کنید"}
            />
        </AuthMain>
    );
};
export default RequestForgetPassword;
